import { render, staticRenderFns } from "./DMATable2.vue?vue&type=template&id=cb1210a4&scoped=true"
import script from "./DMATable2.vue?vue&type=script&lang=js"
export * from "./DMATable2.vue?vue&type=script&lang=js"
import style0 from "./DMATable2.vue?vue&type=style&index=0&id=cb1210a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1210a4",
  null
  
)

export default component.exports